import { Component, Input, OnInit } from '@angular/core';
import { VisualItemInfo } from '../../models/visual-item-info';

@Component({
  selector: 'app-visual-item-info',
  templateUrl: './visual-item-info.component.html',
  styleUrls: ['./visual-item-info.component.css']
})
export class VisualItemInfoComponent implements OnInit {

  @Input() visualItemInfo: VisualItemInfo;

  constructor(
  ) { }

  ngOnInit() {
  }

}
